<ng-container *ngIf="layout == 'vertical'">

    <div class="navbar-vertical">

        <div class="navbar-header">

            <div class="logo">
                <img class="logo-icon" src="/images/logo.svg">
                <span id="navbarAppName" class="logo-text">{{this.appName}}</span>
            </div>

            <button id="btnNavbarToggleShow" class="toggle-button-navbar mat-icon-button center-content"
                (click)="toggleSidebarFolded('navbar')" fxHide.lt-lg>
                <i class="material-icons icon">menu</i>
            </button>

            <button id="btnNavbarToggleHide" mat-button class="toggle-button-navbar mat-icon-button center-content"
                (click)="toggleSidebarOpened('navbar')" fxHide.gt-md>
                <i class="material-icons icon">arrow_back</i>
            </button>

        </div>

        <div class="navbar-content ps ps--active-y" fusePerfectScrollbar>
            <fuse-navigation [navigation]="navigation" layout="vertical"></fuse-navigation>
        </div>

    </div>

</ng-container>

<ng-container *ngIf="layout == 'horizontal'">

    <div class="navbar-horizontal">
        <fuse-navigation [navigation]="navigation" layout="horizontal"></fuse-navigation>
    </div>

</ng-container>